import React from 'react';
import { Helmet } from 'react-helmet';

const Pricing = () => {
  return (
    <div style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif", lineHeight: '1.6', color: '#333', background: '#f5f5f5', minHeight: '100vh' }}>
      <Helmet>
        <title>Pricing | SugarHathi</title>
        <meta name="description" content="SugarHathi platform pricing for sugar trading, logistics, and market intelligence services." />
      </Helmet>
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px', background: 'white', minHeight: '100vh' }}>

        <div style={{ textAlign: 'center', marginBottom: '40px', paddingBottom: '20px', borderBottom: '3px solid #2ecc71' }}>
          <h1 style={{ fontSize: '2.5rem', color: '#2ecc71', margin: '0 0 10px 0', padding: 0 }}>Pricing</h1>
          <p style={{ color: '#666', fontSize: '0.95rem', margin: '0 0 5px 0' }}><strong style={{ color: '#2c3e50' }}>Villgrains FarmTech Private Limited</strong></p>
          <p style={{ color: '#666', fontSize: '0.95rem', margin: 0 }}>Last Updated: June 7, 2026</p>
        </div>

        <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
          SugarHathi is free to use for registration and browsing. The following fees apply for specific services.
        </p>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>1. Platform Fees</h2>
          <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', margin: '15px 0' }}>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Registration:</strong> Free</p>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Browsing:</strong> Free</p>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Booking:</strong> Free</p>
            <p style={{ marginBottom: 0 }}><strong style={{ color: '#2c3e50' }}>Live Delivery Tracking:</strong> ₹199 per booking — one time, non-refundable once activated</p>
          </div>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>2. Sugar Pricing</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            Sugar prices are listed per metric tonne inclusive of applicable GST. Prices are subject to
            change without prior notice. The price at time of booking confirmation is the binding price.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>3. Payment</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            All payments are processed securely via <strong style={{ color: '#2c3e50' }}>Razorpay</strong>.
            Accepted methods include RTGS, NEFT, and UPI. Payment must be completed before dispatch is authorized.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>4. Contact</h2>
          <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', margin: '15px 0' }}>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Email:</strong> info@villagegrains.com</p>
            <p style={{ marginBottom: 0 }}><strong style={{ color: '#2c3e50' }}>WhatsApp:</strong> +91 79899 53468</p>
          </div>
        </section>

        <div style={{ textAlign: 'center', marginTop: '50px', paddingTop: '30px', borderTop: '2px solid #e0e0e0', color: '#666', fontSize: '0.9rem' }}>
          <p style={{ marginBottom: '5px' }}>&copy; 2026 Villgrains FarmTech Private Limited. All rights reserved.</p>
          <p style={{ margin: 0 }}>Trading as SugarHathi</p>
        </div>

      </div>
    </div>
  );
};

export default Pricing;
